export const RELOAD_KEY = 'vite-preload-reloaded';

// Same wording TanStack Router's isModuleNotFoundError matches. Used only to classify for Sentry-noise suppression; reload recovery is already owned by vite:preloadError and lazyRouteComponent.
export const DYNAMIC_IMPORT_ERROR_PATTERN =
  /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module/i;

export function isDynamicImportLoadError(error: unknown): boolean {
  return error instanceof Error && DYNAMIC_IMPORT_ERROR_PATTERN.test(error.message);
}

// Reloads once per tab (sessionStorage guard) to recover from stale chunks after a deploy.
export function bootstrapPreloadErrorReload(): void {
  window.addEventListener('vite:preloadError', () => {
    try {
      if (sessionStorage.getItem(RELOAD_KEY) !== null) {
        return;
      }
      sessionStorage.setItem(RELOAD_KEY, '1');
    } catch {
      return;
    }
    window.location.reload();
  });
}
